import _styled, { default as _styled2 } from "styled-components";
var _templateObject;
var _excluded = ["direction", "size"];
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { IconArrowBack } from "../../foundations/Iconography/IconArrowBack";
import { IconArrowForward } from "../../foundations/Iconography/IconArrowForward";
import { RoundButton } from "./RoundButton/RoundButton";
import * as styles from "./styles";
import { ACTION_BUTTON_SIZE_MAP } from "../../../constants/actionButtons";
/** @deprecated use `IconButton` instead */
export var ArrowButton = function ArrowButton(_ref) {
  var direction = _ref.direction,
    size = _ref.size,
    props = _objectWithoutProperties(_ref, _excluded);
  var iconSize = ACTION_BUTTON_SIZE_MAP[size];
  var className = props.disabled ? styles.iconDisabled : undefined;
  return /*#__PURE__*/React.createElement(RoundButton, _extends({
    size: size
  }, props), direction === 'left' ? /*#__PURE__*/React.createElement(_StyledIconArrowBack, {
    height: iconSize,
    width: iconSize,
    $_css: className
  }) : /*#__PURE__*/React.createElement(_StyledIconArrowForward, {
    height: iconSize,
    width: iconSize,
    $_css2: className
  }));
};
var _StyledIconArrowBack = _styled(IconArrowBack)(_templateObject || (_templateObject = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css;
});
var _StyledIconArrowForward = /*#__PURE__*/_styled2(IconArrowForward).withConfig({
  displayName: "ArrowButton___StyledIconArrowForward",
  componentId: "sc-3ykdbx-0"
})(["", ""], function (p) {
  return p.$_css2;
});